module.exports = __webpack_public_path__ + "staticcomp/img/more_articles.5e940a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/more_articles.png
// module id = 5twm
// module chunks = 39